import { GATES } from '../constants/auth';
import { useGetIsUngated } from './useGetIsUngated';
import { useHasQuotesTeamBeta } from './useHasQuotesTeamBeta';
export const useHasSeqReqChangesRedesign = () => {
  const getIsUngated = useGetIsUngated();
  // NOTE: Quotes needs the SeqReqChanges redesign for their team-based-approvals
  // beta, so the commerce:qmgmt:TeamBasedApprovals gate opts users into the
  // redesign as well.
  const hasQuotesTeamBeta = useHasQuotesTeamBeta();
  return getIsUngated(GATES.SEQ_REQ_CHANGES_REDESIGN) || hasQuotesTeamBeta;
};